import React from "react";

import classNames from "classnames";
import isEmpty from "lodash.isempty";
import { observer } from "mobx-react";
import Link from "next/link";
import styled from "styled-components";

import { useStores } from "../../contexts/StoreContext";
import useDevice from "../../shared/customHooks/useDevice";
import AdditionalFooter from "./AdditionalFooter";
import ContactInfo from "./ContactInfo";
import ModeToggle from "./ModeToggle";
import NavigationColumns from "./NavigationColumns";
import SocialMediaLinks from "./SocialMediaLinks";

const StyledFooter = styled.footer`
  background-color: ${({ theme, $backgroundColour }) =>
    $backgroundColour || theme.footerBackgroundColor};
  color: ${({ theme }) => theme.negativeTextColor};

  a {
    text-decoration: none;
    color: ${({ $linkColor }) => `${$linkColor || "inherit"}`};

    &:hover {
      text-decoration: underline;
    }
  }
`;

function DefaultFooter(props) {
  const { navigationStore, footerStore } = useStores();

  const {
    footerLinks,
    additionalFooterNavigation,
    isAdditionalFooterNavigationUsed,
  } = navigationStore;

  const { externalClasses, iconColor, isRowReversed, linkColor } = footerStore;

  const { isMobile } = useDevice();

  const navigationColumnsClassName = classNames({
    "col-md-4": isEmpty(externalClasses),
    "d-flex": !isEmpty(externalClasses),
    [externalClasses]: !isEmpty(externalClasses),
    "flex-column-reverse align-items-center": isMobile,
    "justify-content-between": isRowReversed,
  });

  const socialMediaLinksClassName = classNames({
    "mb-5": isMobile,
    "ms-3": !isMobile,
  });

  const listClassName = classNames({
    "mb-3 mx-4 text-center": isMobile,
    "mb-5": !isMobile,
  });

  const contactSectionClassName = classNames(
    "col-md-5 ms-auto col-lg-4 col-xl-3",
    {
      "mb-5": isAdditionalFooterNavigationUsed,
    }
  );

  return (
    <StyledFooter
      $linkColor={linkColor}
      $backgroundColour={props?.backgroundColour}
    >
      <div className="container-xxl py-4">
        <div className="row">
          {!isEmpty(footerLinks) && (
            <div className={navigationColumnsClassName}>
              <NavigationColumns
                listClassName={listClassName}
                navigationLinks={footerLinks}
              />
              {isRowReversed && (
                <SocialMediaLinks
                  iconColor={iconColor}
                  mediaLinksWrapperClassName={socialMediaLinksClassName}
                />
              )}
            </div>
          )}
          <div className={contactSectionClassName}>
            {!isRowReversed && <SocialMediaLinks iconColor={iconColor} />}
            <ContactInfo />
            {!isAdditionalFooterNavigationUsed && (
              <div className="m-0 text-end">
                <span className="me-5">
                  Site by <a href="https://talent-funnel.com">Talent Funnel</a>
                </span>
                <Link href="/sitemap">Sitemap</Link>
              </div>
            )}
          </div>
          {isAdditionalFooterNavigationUsed && (
            <AdditionalFooter
              additionalFooterNavigation={additionalFooterNavigation}
            />
          )}
        </div>
        <ModeToggle />
      </div>
    </StyledFooter>
  );
}

export default observer(DefaultFooter);
